/** 
  All of the routes for the Flex2 are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/


import Shop from "pages/components/Icons/Shop";
import Office from "pages/components/Icons/Office";
import SettingsIcon from "pages/components/Icons/Settings";
import Basket from "pages/components/Icons/Basket";
import Document from "pages/components/Icons/Document";
const LoginScreen = lazy(() => import("pages/Login"));
const RegistrationScreen = lazy(() => import("pages/Registeration"));
const Setting = lazy(() => import("pages/Settings"));
const DashboardScreen = lazy(() => import("pages/Dashboard"));
const UserListingScreen = lazy(() => import("pages/Users/Listing"));
const DeviceManagement = lazy(() => import("pages/DeviceManagement/DeviceListing"));
const BindDevice = lazy(() => import("pages/DeviceManagement/BindDevice"));
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// material icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import PaymentsIcon from "@mui/icons-material/Payments";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import MessageIcon from "@mui/icons-material/Message";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import DiscountOutlinedIcon from "@mui/icons-material/DiscountOutlined";
import PostAddIcon from "@mui/icons-material/PostAdd";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import HelpIcon from "@mui/icons-material/Help";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import FilterVintageIcon from "@mui/icons-material/FilterVintage";
import DevicesIcon from "@mui/icons-material/Devices";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import WidgetsIcon from "@mui/icons-material/Widgets";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ProtectedRoute from "ProtectedRoute";
import VendorErrorBoundary from "components/VendorErrorBoundary";
const AgentRunsScreen = lazy(() => import("pages/AgentRuns"));
const AgentRunDetailScreen = lazy(() => import("pages/AgentRuns/RunDetail"));
const AgentApprovalsScreen = lazy(() => import("pages/AgentApprovals"));
const PartsMasterReviewScreen = lazy(() => import("pages/VendorProgram/PartsMasterReview"));
const OrganizationRelationshipsScreen = lazy(() => import("pages/VendorProgram/OrganizationRelationships"));
const VendorSitesScreen = lazy(() => import("pages/VendorProgram/VendorSites"));
const QuoteOrderRequestsScreen = lazy(() => import("pages/VendorProgram/QuoteOrderRequests"));
const ApprovedHardwareProductsScreen = lazy(() => import("pages/HardwareAdmin/ApprovedProducts"));
const HardwareCategoriesScreen = lazy(() => import("pages/HardwareAdmin/HardwareCategories"));
const HardwareOrdersScreen = lazy(() => import("pages/HardwareAdmin/HardwareOrders"));
const DeviceInstallationsScreen = lazy(() => import("pages/HardwareAdmin/DeviceInstallations"));
const AuditEventsScreen = lazy(() => import("pages/AuditEvents"));
const EntitlementsScreen = lazy(() => import("pages/Entitlements"));
const SkusScreen = lazy(() => import("pages/Skus"));
const PelicanSitesScreen = lazy(() => import("pages/PelicanSites"));
const PelicanSiteOverview = lazy(() => import("pages/PelicanSites/SiteDetail/Overview"));
const PelicanSiteOperations = lazy(() => import("pages/PelicanSites/SiteDetail/Operations"));
const PelicanClimate = lazy(() => import("pages/PelicanSites/SiteDetail/Climate"));
const PelicanSchedules = lazy(() => import("pages/PelicanSites/SiteDetail/Schedules"));
const PelicanPower = lazy(() => import("pages/PelicanSites/SiteDetail/Power"));
const PelicanNotifications = lazy(() => import("pages/PelicanSites/SiteDetail/Notifications"));
const PelicanUsage = lazy(() => import("pages/PelicanSites/SiteDetail/Usage"));
const PelicanAutomation = lazy(() => import("pages/PelicanSites/SiteDetail/Automation"));
const TaxonomyScreen = lazy(() => import("pages/Taxonomy"));
const TaxonomyCrmRulesScreen = lazy(() => import("pages/Taxonomy/CrmRules"));
const TaxonomyPermissionTemplatesScreen = lazy(() => import("pages/Taxonomy/PermissionTemplates"));
const TaxonomyPartnerProfilesScreen = lazy(() => import("pages/Taxonomy/PartnerProfiles"));
const TaxonomyPartnerLocatorScreen = lazy(() => import("pages/Taxonomy/PartnerLocator"));
const TaxonomyStaleFamiliesScreen = lazy(() => import("pages/Taxonomy/StaleFamilies"));
const AfmsWorkflowScreen = lazy(() => import("pages/AfmsWorkflow"));
import HubIcon from "@mui/icons-material/Hub";
import AbacProtectedRoute from "components/AbacProtectedRoute";
import { RESOURCE_TYPES, ACTIONS } from "utils/abacConstants";
const ViewDevice = lazy(() => import("pages/DeviceManagement/ViewDevice"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const Cookies = lazy(() => import("pages/Cookies"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const AuthCheck = lazy(() => import("pages/AuthCheck"));
const AuthCallback = lazy(() => import("pages/AuthCallback"));
// One-time links emailed by flex2-api (sign-in link, welcome "set your password").
const LoginLink = lazy(() => import("pages/LoginLink"));
const SetPassword = lazy(() => import("pages/SetPassword"));
const SecurityPage = lazy(() => import("pages/Account/Security"));
import LocationOnIcon from "@mui/icons-material/LocationOn";
const Locations = lazy(() => import("pages/Locations"));
import HomeMaxIcon from "@mui/icons-material/HomeMax";
import InventoryIcon from "@mui/icons-material/Inventory";
import MemoryRoundedIcon from "@mui/icons-material/MemoryRounded";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import SupportIcon from "@mui/icons-material/Support";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
const AddAsset = lazy(() => import("pages/AssetsManagement/AddAssets"));
import AssetsTree from "pages/AssetsManagement/AssetsTree";
const AssetsList = lazy(() => import("pages/AssetsManagement/AssetsListings/index.js"));
const EditAsset = lazy(() => import("pages/AssetsManagement/EditAsset"));
const AddSensor = lazy(() => import("pages/AssetsManagement/AddAssets/AddSensor"));
const AcceptInvitation = lazy(() => import("pages/AceeptInvitation"));
const Departments = lazy(() => import("pages/OrganizationManagement/Departments"));
const KeycloakLookup = lazy(() => import("pages/OrganizationManagement/Keycloak"));
const FormHistoryPage = lazy(() => import("pages/Inspections/FormHistoryPage"));
const Roles = lazy(() => import("pages/OrganizationManagement/Roles"));
const LocationPermissions = lazy(() => import("pages/OrganizationManagement/Roles/LocationPermissions"));
const DevicePermissions = lazy(() => import("pages/OrganizationManagement/Roles/DevicePermissions"));
const Invitations = lazy(() => import("pages/OrganizationManagement/Invitations/index.js"));
const OrganizationUsers = lazy(() => import("pages/OrganizationManagement/OrganizationUsers/index.js"));
const Organizations = lazy(() => import("pages/OrganizationManagement/Organizations"));
const CreateOrganization = lazy(() => import("pages/OrganizationManagement/Organizations/CreateOrganization"));
const Qualifications = lazy(() => import("pages/OrganizationManagement/Qualifications"));
const SwitchOrg = lazy(() => import("pages/SwitchOrg"));
const AddLocationPermissions = lazy(() => import("pages/OrganizationManagement/Roles/AddLocationPermissions"));
const NotificationScreen = lazy(() => import("pages/AssetsManagement/AssetsNotifications"));
const AddNotificationScreen = lazy(() => import("pages/AssetsManagement/AssetsNotifications/AddNotification"));
const WidgetListing = lazy(() => import("pages/Widgets/index.js"));
const NotificationHistory = lazy(() => import("pages/AssetsManagement/NotificationHistory/index.js"));
const DeviceAuthListings = lazy(() => import("pages/DeviceAuth/DeviceAuthListings/index.js"));
const DeviceSetup = lazy(() => import("pages/DeviceAuth/DeviceSetup"));
const CompanyListing = lazy(() => import("pages/CompanyListing"));
const DeviceStyles = lazy(() => import("pages/DeviceStyles/index.js"));
const PaymentScreens = lazy(() => import("pages/PaymentScreens"));
const SubscriptionListing = lazy(() => import("pages/PaymentsManagment/Subscriptions/index.js"));
const SubscriptionDetails = lazy(() => import("pages/PaymentsManagment/SubscriptionDetails"));
const Prices = lazy(() => import("pages/PaymentsManagment/Prices/index.js"));
const AddCustomSubscription = lazy(() => import("pages/PaymentsManagment/Subscriptions/AddCustomSubscription"));
const CheckoutScreen = lazy(() => import("pages/CheckoutScreen"));
const UserSubscriptions = lazy(() => import("pages/UserSubscriptions/index.js"));
const MySubscription = lazy(() => import("pages/UserSubscriptions/MySubscription"));
const CompanyDetails = lazy(() => import("pages/CompanyListing/CompanyDetails"));
const BusinessCheckout = lazy(() => import("pages/BusinessCheckout"));
const SubscriptionPlans = lazy(() => import("pages/PaymentsManagment/SubscriptionPlans/index.js"));
const FlexProducts = lazy(() => import("pages/FlexProducts/Products/index.js"));
const AddFlexProduct = lazy(() => import("pages/FlexProducts/AddFlexProduct"));
const EditFlexProduct = lazy(() => import("pages/FlexProducts/EditFlexProduct"));
const ViewFlexProductPage = lazy(() => import("pages/FlexProducts/ViewFlexProduct"));
const ContactMessages = lazy(() => import("pages/ContactMessages"));
const ContactMessageDetails = lazy(() => import("pages/ContactMessages/ContactMessageDetails"));
const LeadsManagement = lazy(() => import("pages/LeadsManagement"));
const LeadDetails = lazy(() => import("pages/LeadsManagement/LeadDetails"));
const ProductCategories = lazy(() => import("pages/ProductCategories"));
const BrandsListing = lazy(() => import("pages/Products/ProductBrands/BrandsListing/index.js"));
const ProductClasses = lazy(() => import("pages/Products/ProductClasses"));
const InventoryLocations = lazy(() => import("pages/Products/InventoryLocations"));
const CompanyTypes = lazy(() => import("pages/Business/CompanyTypes/index.js"));
const DevicePlan = lazy(() => import("pages/DeviceManagement/DevicePlan"));
const DeviceCheckoutScreen = lazy(() => import("pages/DeviceCheckoutScreen"));
const SubscriptionPayment = lazy(() => import("pages/SubscriptionPayment"));
const PaymentMethods = lazy(() => import("pages/UserSubscriptions/PaymentMethods"));
const CustomerListingScreen = lazy(() => import("pages/CustomerManagement/Listing"));
const WorkOrders = lazy(() => import("pages/WorkOrders"));
const CreateWorkOrder = lazy(() => import("pages/WorkOrders/CreateWorkOrder"));
const OrdersPage = lazy(() => import("pages/Products/Orders/index.js"));
import VendorList from "pages/VendorManagement/VendorListings/index.js";
import AddVendor from "pages/VendorManagement/AddVendor";
import ViewVendorDetails from "pages/VendorManagement/ViewVendorDetails";
const AssetClasses = lazy(() => import("pages/AssetsManagement/AssetClasses"));
const ServiceStatus = lazy(() => import("pages/ServiceStatus/index.js"));
const OrderDetails = lazy(() => import("pages/Products/Orders/OrderDetails"));
const VendorListingPage = lazy(() => import("pages/OrganizationManagement/Vendors"));
const CustomerListingPage = lazy(() => import("pages/OrganizationManagement/Customers"));
const TicketListingScreen = lazy(() => import("pages/TicketManagement/index.js"));
const AddPart = lazy(() => import("pages/PartManagement/AddPart"));
const EditPart = lazy(() => import("pages/PartManagement/EditPart"));
const PartDetails = lazy(() => import("pages/PartManagement/PartDetails"));
const PartsListing = lazy(() => import("pages/PartManagement/PartsListing"));
const PartType = lazy(() => import("pages/PartManagement/PartType/index.js"));
const ServicesListing = lazy(() => import("pages/ServicesManagement/ServicesListing"));
const AddService = lazy(() => import("pages/ServicesManagement/AddService"));
const EditService = lazy(() => import("pages/ServicesManagement/EditService"));
const CreateTicket = lazy(() => import("pages/TicketManagement/CreateTicket"));
const TicketDetails = lazy(() => import("pages/TicketManagement/TicketDetails"));
const Teams = lazy(() => import("pages/OrganizationManagement/Teams"));
const TeamUsers = lazy(() => import("pages/OrganizationManagement/Teams/TeamUsers"));
const Presentation = lazy(() => import("pages/Presentation"));
const ClaimedDevices = lazy(() => import("pages/ClaimedDevices/index.js"));
const DeviceConfig = lazy(() => import("pages/ClaimedDevices/DeviceConfig"));
const VendorDetails = lazy(() => import("pages/OrganizationManagement/Vendors/VendorDetails"));
const WorkOrderDetails = lazy(() => import("pages/WorkOrders/WorkOrderDetails"));
const MyDashboardPage = lazy(() => import("pages/Dashboard/MyDashboard"));
const OperationsDashboard = lazy(() => import("pages/Dashboard/OperationsDashboard"));
const TaskManagementPage = lazy(() => import("pages/TaskManagement"));
const CreateTaskPage = lazy(() => import("pages/TaskManagement/CreateTask"));
const TaskDetailsPage = lazy(() => import("pages/TaskManagement/TaskDetails"));
const ManufacturerListing = lazy(() => import("pages/FlexProducts/Manufacturer/ManufacturerListing/index.js"));
const ModelsListing = lazy(() => import("pages/FlexProducts/Model/ModelsListing/index.js"));
const ServiceParts = lazy(() => import("pages/FlexProducts/ServiceParts"));
const InspectionForm = lazy(() => import("pages/Inspections/InspectionForm"));
const InspectionFormsListing = lazy(() => import("pages/Inspections/InspectionFormsListing"));
const Systems = lazy(() => import("pages/Library/Systems"));
const SystemCategoriesListing = lazy(() => import("pages/AssetsManagement/SystemCategories/SystemCategoriesListing/index.js"));
const UserDetails = lazy(() => import("pages/OrganizationManagement/Customers/UserDetails"));
const EntityListing = lazy(() => import("pages/EntityManagement/EntityListing/index.js"));
const EmployeeListing = lazy(() => import("pages/EntityManagement/EmployeeListing"));
const AnnualInspectionCertificateandChecklist = lazy(() => import("pages/Inspections/AnnualInspectionCertificateandChecklist"));
const InspectionPreview = lazy(() => import("pages/Inspections/InspectionPreview"));
const AnnualInspectionPdf = lazy(() => import("pages/Inspections/InspectionPreview/AnnualInspectionPdf"));
const CompanyDepartments = lazy(() => import("pages/EntityManagement/Departments"));
const CompanyQualifications = lazy(() => import("pages/EntityManagement/Qualifications"));
const CompanyInvitations = lazy(() => import("pages/EntityManagement/Invitations/index.js"));
const CompanyTeams = lazy(() => import("pages/EntityManagement/Teams"));
const CompanyTeamUsers = lazy(() => import("pages/EntityManagement/Teams/TeamUsers"));
const CompanySystemTree = lazy(() => import("pages/EntityManagement/CompanySystemTree"));
const AdminOrders = lazy(() => import("pages/AdminOrders/index.js"));
const AdminOrderDetails = lazy(() => import("pages/AdminOrders/AdminOrderDetails"));
const AdminOrganisations = lazy(() => import("pages/AdminOrganisations/index.js"));
const RecyclingTypesAdmin = lazy(() => import("pages/RecyclingTypesAdmin/index.js"));
const EnvironmentalSubscriptionsAdmin = lazy(() => import("pages/EnvironmentalSubscriptionsAdmin"));
const DeviceStyleTelemetryAdmin = lazy(() => import("pages/DeviceStyleTelemetryAdmin/index.js"));
const AdminOpsTools = lazy(() => import("pages/AdminOpsTools"));
const CodePlans = lazy(() => import("pages/CodePlans"));
const TrialsAdmin = lazy(() => import("pages/TrialsAdmin"));
const ProductChannelsListing = lazy(() => import("pages/FlexProducts/ProductChannels/ProductChannelsListing/index.js"));
const AddMaintenancePage = lazy(() => import("pages/AssetsManagement/EditAsset/components/AddMaintenancePage"));
const ConfiguratorTemplates = lazy(() => import("pages/ProductConfigurator/Templates/index.js"));
const ConfiguratorOptionGroups = lazy(() => import("pages/ProductConfigurator/OptionGroups/index.js"));
const ConfiguratorOptions = lazy(() => import("pages/ProductConfigurator/Options/index.js"));
const ConfiguratorRules = lazy(() => import("pages/ProductConfigurator/Rules"));
const ConfiguratorPricingRules = lazy(() => import("pages/ProductConfigurator/PricingRules/index.js"));

import CreateCompanyPage from "pages/EntityManagement/EntityListing/CreateCompany";
import EditCompanyPage from "pages/EntityManagement/EntityListing/EditCompany";
const AddressesListing = lazy(() => import("pages/OrganizationManagement/Addresses/index.js"));
const CreateAddressPage = lazy(() => import("pages/OrganizationManagement/Addresses/CreateAddressPage"));
const EditAddressPage = lazy(() => import("pages/OrganizationManagement/Addresses/EditAddressPage"));
const EditTicket = lazy(() => import("pages/TicketManagement/EditTicket"));
import TimelineIcon from "@mui/icons-material/Timeline";
const ActivityScreen = lazy(() => import("pages/Activity"));

const EditModel = lazy(() => import("pages/FlexProducts/Model/EditModel"));
// Quotations imports — re-enabled so the Fixed Ops portal's Quotations
// sidebar entry resolves. The legacy MAIN sidebar's Quotations menu
// reappears as a side effect; restrict its visibility there if not
// desired (it's gated by `roles: [...]` on the collapse entry).
import AdminQuotationListing from "pages/Quotes/AdminQuotes/AdminQuotationListing";
import UserQuotationListing from "pages/Quotes/UserQuotes/UserQuotationListing";
import UserQuotationDetails from "pages/Quotes/UserQuotes/UserQuotationDetails";
import UserQuotationOnlineCheckout from "pages/Quotes/UserQuotes/UserQuotationOnlineCheckout";
import AdminQuotationPreview from "pages/Quotes/AdminQuotes/AdminQuotationPreview";
const TimeTracker = lazy(() => import("pages/TimeTracker"));
const TrackerReport = lazy(() => import("pages/TimeTracker/TrackerReport"));
// import TimeTrackedInvoice from "pages/TimeTracker/TrackerReport/TimeTrackedInvoice";
const InvoicePDF = lazy(() => import("pages/TimeTracker/TrackerReport/InvoicePDF"));
const TimeTrackerCreateInvoice = lazy(() => import("pages/TimeTracker/TrackerReport/TimeTrackerCreateInvoice"));
const ProductListPage = lazy(() => import("pages/OrderProducts/ProductList"));
const ProductSearch = lazy(() => import("pages/OrderProducts/ProductSearch"));
const ProductDetails = lazy(() => import("pages/OrderProducts/ProductDetails"));
const OrderCheckout = lazy(() => import("pages/OrderProducts/OrderCheckout"));
const OrderCart = lazy(() => import("pages/OrderProducts/Cart"));
const Discounts = lazy(() => import("pages/PaymentsManagment/Discounts/index.js"));
const AssignedProducts = lazy(() => import("pages/CompanyListing/AssignedProducts/index.js"));
const EnergyChart = lazy(() => import("pages/Dashboard/EnergyDashboard/EnergyChart"));
const CreateInspectionForm = lazy(() => import("pages/Inspections/InspectionForm/CreateInspectionForm"));
const AbacAdmin = lazy(() => import("pages/AbacAdmin"));
const PlatformAbac = lazy(() => import("pages/PlatformAbac"));
const SettingsAbac = lazy(() => import("pages/SettingsAbac"));
const OrganizationAdmin = lazy(() => import("pages/OrganizationAdmin"));
const OrganizationExplorer = lazy(() => import("pages/OrganizationExplorer"));
const ImpersonationLogs = lazy(() => import("pages/ImpersonationLogs"));
// LCP Global Tasks/Comments/Deferrals moved to the LCP portal (org-owned
// Resources Setup). Lift Models stayed backoffice but now curate the shared
// GLOBAL catalog (org_id NULL); orgs add their own via Resources Setup.
const LcpLiftModelsAdmin = lazy(() => import("lcp/pages/LiftModelsAdmin"));
const LcpLiftParts = lazy(() => import("pages/LcpLiftParts"));
const LcpApprovalsInspector = lazy(() => import("pages/LcpApprovalsInspector"));
const LcpLabelOrders = lazy(() => import("pages/LcpLabelOrders"));
const LcpInspectionAudit = lazy(() => import("pages/LcpInspectionAudit"));
const LcpChecklistPins = lazy(() => import("pages/LcpChecklistPins"));
const PlatformHealth = lazy(() => import("pages/PlatformHealth"));
const SqlConsole = lazy(() => import("pages/SqlConsole"));
const S3Explorer = lazy(() => import("pages/S3Explorer"));
const WorkCommits = lazy(() => import("pages/WorkCommits"));
const AiSettings = lazy(() => import("pages/AiSettings"));
import PolicyIcon from "@mui/icons-material/Policy";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
const PlatformNotifications = lazy(() => import("pages/PlatformNotifications"));
const PlatformUserSecurity = lazy(() => import("pages/Platform/UserSecurity"));
import afmsRoutes from "afms/routes";
import fixedOpsRoutes from "fixedops/routes";
import lcpRoutes from "lcp/routes";
// Plan K Phase 3 — Energy Management lane (scaffold). The module ships an
// Overview shell only; future phases add HVAC / compressed-air / dryer /
// current-sense dashboards. Lane-gated by `lane.energy_management`.
import EnergyHandoff from "energy/EnergyHandoff";
import TrainingHandoff from "training/TrainingHandoff";
import InspectionsHandoff from "inspections-handoff/InspectionsHandoff";
import SiteHandoff from "site/SiteHandoff";
// Plan K Phase 4 — SpendGuard lane. Feature area inside flex2-api; dashboard
// hub showing which tier features the org has unlocked. Lane-gated by
// `lane.spendguard`.
import spendguardRoutes from "spendguard/routes";
// Plan K Phase 5 — Enterprise Action Engine lane. Cross-module hub for agent
// runs, action requests, and leadership briefings. Lane-gated by
// `lane.enterprise_action_engine`. AFMS-scoped Morning Briefing pages stay
// where they are (under src/afms/pages/Briefing/) — Enterprise is additive.
import enterpriseRoutes from "enterprise/routes";
// Plan K Phase 6 — Lockout / Tagout module (separate from AFMS per design
// decision). Electrical panels + breakers + asset-feed mappings on top of
// loto-api. Currently lane-gated under `lane.environmental`; can move to its
// own lane if LOTO gets a dedicated pricing lane.
import lotoRoutes from "loto/routes";
// audit-api admin viewer. v2 of audit-api adds per-org hash-chain verification;
// this module provides the admin viewer surface. Platform-admin lane only.
import auditApiRoutes from "audit/routes";
// Plan L Phase L1 — Generic Inspection microservice (inspections-api on
// port 5054, schema `inspections.*`). Platform-core capability — no lane
// gate. Phase L1 ships an Overview shell; full inspection UI lands in
// Phase L3 on top of the Phase L2 domain.
// Plan L Phase L5 — Safety & Compliance aggregator lane.
import safetyRoutes from "safety/routes";
import AdminQuotationCreate from "pages/Quotes/AdminQuotes/AdminQuotationCreate";
import AdminQuotationDetails from "pages/Quotes/AdminQuotes/AdminQuotationDetails";
const AdminInvoicePreview = lazy(() => import("pages/Quotes/AdminQuotes/AdminInvoicePreview"));
const InvoiceListing = lazy(() => import("pages/InvoiceQuotes/InvoiceListing"));
const PickupInvoicesListing = lazy(() => import("pages/PickupInvoicesListing"));
const AfmsPayables = lazy(() => import("afms/pages/Payables"));
// Pickups history — vendor side (/vendor/pickups, next to Receivables) and
// client side (/pickups, next to Payables). Same page, two scopes.
const AfmsVendorPickups = lazy(() => import("afms/pages/PickupsHistory"));
const AfmsClientPickups = lazy(() => import("afms/pages/PickupsHistory/ClientPickups"));
const CreateInvoice = lazy(() => import("pages/InvoiceQuotes/CreateInvoice"));
const CreateQuotes = lazy(() => import("pages/InvoiceQuotes/CreateQuotes"));
const ViewInvoice = lazy(() => import("pages/InvoiceQuotes/ViewInvoice"));
const ViewQuaoteInvoice = lazy(() => import("pages/InvoiceQuotes/ViewQuaoteInvoice"));

// Vendor Portal lazy-loaded pages
import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GroupIcon from "@mui/icons-material/Group";
const VendorDashboard = React.lazy(() => import("pages/VendorPortal/VendorDashboard"));
const VendorDashboardRouter = React.lazy(() => import("pages/VendorPortal/VendorDashboardRouter"));
const ClientOrgs = React.lazy(() => import("pages/VendorPortal/ClientOrgs"));
const DeviceOverview = React.lazy(() => import("pages/VendorPortal/DeviceOverview"));
const AlertManagement = React.lazy(() => import("pages/VendorPortal/AlertManagement"));
const TicketOverview = React.lazy(() => import("pages/VendorPortal/TicketOverview"));
const VendorAccessManagement = React.lazy(() =>
  import("pages/VendorPortal/VendorAccessManagement")
);
const ClientSiteOverview = React.lazy(() => import("pages/VendorPortal/ClientSiteOverview"));
const ClientTankListing = React.lazy(() => import("pages/VendorPortal/ClientTankListing"));
const ClientTankDetail = React.lazy(() => import("pages/VendorPortal/ClientTankDetail"));
const VendorReport = React.lazy(() => import("pages/VendorPortal/VendorReport"));
const CommandCenter = React.lazy(() => import("afms/pages/CommandCenter"));
const SecureLinkRedeem = React.lazy(() => import("afms/pages/SecureLinkRedeem"));
// WS92: the driver's QR pickup page — public (PIN or sign-in is decided inside).
const DriverPickup = React.lazy(() => import("afms/pages/Driver"));
// AFMS-rebranded Settings pages — own-org scoped wrappers around existing flex2 logic.
const AfmsSettingsOrganization = React.lazy(() => import("afms/pages/Settings/Organization"));
const AfmsSettingsUsers = React.lazy(() => import("afms/pages/Settings/Users"));
const AfmsSettingsAssets = React.lazy(() => import("afms/pages/Settings/Assets"));
const AfmsSettingsDevices = React.lazy(() => import("afms/pages/Settings/Devices"));
const AfmsSettingsTickets = React.lazy(() => import("afms/pages/Settings/Tickets"));
const Lazy = ({ children }) => (
  <Suspense fallback={<div style={{ padding: "2rem", textAlign: "center" }}>Loading...</div>}>
    {children}
  </Suspense>
);
const VendorLazy = ({ children }) => (
  <VendorErrorBoundary>
    <Suspense fallback={<div style={{ padding: "2rem", textAlign: "center" }}>Loading...</div>}>
      {children}
    </Suspense>
  </VendorErrorBoundary>
);

// Origin of devices-webapp, the separate SPA that owns the Devices pages.
// Blank/absent in every environment where it is not deployed, which is what
// hides the Devices menu below rather than offering a dead link. Trailing
// slashes are trimmed so the href never ends up with "//platform/devices".
const DEVICES_WEBAPP_URL = (process.env.REACT_APP_DEVICES_WEBAPP_URL || "").replace(/\/+$/, "");

// devices-webapp shows a "Back to backoffice" button, and it cannot guess
// where to send you: this app is served by a wildcard, so an admin is on
// whichever org subdomain they signed in to. So tell it. It validates the
// value (https, same registrable domain) before trusting it, and strips the
// parameter from its address bar.
const devicesLink = (path) =>
  `${DEVICES_WEBAPP_URL}${path}?from=${encodeURIComponent(window.location.origin)}`;

const flex2Routes = [
  {
    type: "collapse",
    name: "Home",
    key: "dashboard1",
    icon: <DashboardIcon />,
    appMode: "flex2",
    collapse: [
      // {
      //   name: "Operations Dashboard",
      //   key: "operationsDashboard",
      //   route: "/operations-dashboard",
      //   component: <AbacProtectedRoute component={OperationsDashboard} resourceType={RESOURCE_TYPES.ASSET} action={ACTIONS.VIEW} />,
      // },
      {
        name: "My Dashboard",
        key: "myDashboard",
        route: "/my-dashboard",
        component: (
          <AbacProtectedRoute
            component={MyDashboardPage}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
        hideForVendorOrg: true,
      },
      {
        name: "Device Grid",
        key: "default",
        route: "/dashboard",
        component: (
          <AbacProtectedRoute
            component={DashboardScreen}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
        hideForVendorOrg: true,
      },
      // Vendor org dashboard items — only shown when org is a vendor.
      // AbacProtectedRoute + abacResource/abacAction wire each portal route
      // into the ABAC pipeline: useNavigationFilter hides denied items from
      // the sidenav, and direct URL hits get a 403. vendorOrgOnly is kept as
      // belt-and-suspenders to reduce sidenav flicker while capabilities load.
      {
        name: "Dashboard",
        key: "vendorDashboardInline",
        route: "/vendor/dashboard",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <VendorDashboardRouter />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Command Center",
        key: "vendorCommandCenterInline",
        route: "/afms/command-center",
        component: (
          <ProtectedRoute
            component={
              <VendorLazy>
                <CommandCenter />
              </VendorLazy>
            }
          />
        ),
        vendorOrgOnly: true,
        // Pre-CollapsePrimaryRoles this was gated on the user's
        // RECYCLING_VENDOR primary role. After 2026-06-11 there is no
        // such role; the receiving CommandCenter page now reads the
        // org's `organizationVendorTypes` to decide whether the
        // recycling-flavored ECC tabs render.
      },
      // AFMS-rebranded Settings + Tickets pages. Backend reads/writes are
      // self-or-admin via `[AllowOwnOrgAccess]` on SuperAdminOrganizationController.
      {
        name: "AFMS Settings — Organization",
        key: "afmsSettingsOrganization",
        route: "/afms/settings/organization",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsSettingsOrganization />
              </Lazy>
            }
          />
        ),
      },
      {
        name: "AFMS Settings — Users",
        key: "afmsSettingsUsers",
        route: "/afms/settings/users",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsSettingsUsers />
              </Lazy>
            }
          />
        ),
      },
      {
        name: "AFMS Settings — Assets",
        key: "afmsSettingsAssets",
        route: "/afms/settings/assets",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsSettingsAssets />
              </Lazy>
            }
          />
        ),
      },
      {
        name: "Devices",
        key: "afmsSettingsDevices",
        route: "/afms/settings/devices",
        // `nested: true` flips Sidenav's smaller-font + 22px left margin
        // so this entry visually sits indented under the Assets row above.
        nested: true,
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsSettingsDevices />
              </Lazy>
            }
          />
        ),
      },
      {
        name: "AFMS Settings — Tickets",
        key: "afmsSettingsTickets",
        route: "/afms/settings/tickets",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsSettingsTickets />
              </Lazy>
            }
          />
        ),
      },
      {
        // Receivables — invoices my org has issued (vendor side, lives
        // under Vendor Command Center in the AFMS nav). Hidden from the
        // flex2 Sidenav since vendorNavigation.js already surfaces it.
        key: "afmsReceivables",
        route: "/receivables",
        component: (
          <AbacProtectedRoute resourceType={RESOURCE_TYPES.INVOICE} action={ACTIONS.VIEW}>
            <PickupInvoicesListing mode="sent" />
          </AbacProtectedRoute>
        ),
        hideFromMenu: true,
      },
      {
        // Payables — invoices sent TO my org (client side, lives under
        // EEC → Tickets in the AFMS nav). Hidden for the same reason.
        key: "afmsPayables",
        route: "/payables",
        component: (
          <AbacProtectedRoute resourceType={RESOURCE_TYPES.INVOICE} action={ACTIONS.VIEW}>
            <AfmsPayables />
          </AbacProtectedRoute>
        ),
        hideFromMenu: true,
      },
      {
        // Pickups (vendor side) — every pickup assigned to my vendor org,
        // across all its client orgs. Sits next to Receivables under Vendor
        // Command Center in the AFMS nav, so it's hidden from the flex2
        // Sidenav for the same reason. Authorization is enforced by
        // afms-api (Dispatch.View on /vendor-command-center/pickup-requests),
        // which also resolves which client orgs this vendor may see.
        key: "afmsVendorPickups",
        route: "/vendor/pickups",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsVendorPickups mode="vendor" />
              </Lazy>
            }
          />
        ),
        hideFromMenu: true,
      },
      {
        // Pickups (client side) — only this org's own pickups. The org scope
        // is taken from the token by afms-api, never from a query param, so
        // there is no way for a client to widen it. Lives under EEC next to
        // Payables in the AFMS nav.
        key: "afmsClientPickups",
        route: "/pickups",
        component: (
          <ProtectedRoute
            component={
              <Lazy>
                <AfmsClientPickups />
              </Lazy>
            }
          />
        ),
        hideFromMenu: true,
      },
      {
        // Back-compat redirect for any bookmarks pointing at the old
        // unified listing. Defaults to Payables since that's the more
        // common workflow (every dealer org has bills to triage; only
        // vendor orgs care about Receivables).
        key: "afmsPickupInvoicesRedirect",
        route: "/pickup-invoices",
        component: <Navigate to="/payables" replace />,
        hideFromMenu: true,
      },
      {
        name: "Client Organizations",
        key: "vendorClientsInline",
        route: "/vendor/clients",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <ClientOrgs />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Devices",
        key: "vendorDevicesInline",
        route: "/vendor/devices",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <DeviceOverview />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Alerts",
        key: "vendorAlertsInline",
        route: "/vendor/alerts",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <AlertManagement />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        vendorRoles: ["VENDOR", "RECYCLING_VENDOR"],
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Tickets",
        key: "vendorTicketsInline",
        route: "/vendor/tickets",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.TICKET}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <TicketOverview />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        abacResource: RESOURCE_TYPES.TICKET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Reports",
        key: "vendorReportsInline",
        route: "/vendor/reports",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.TICKET}
            action={ACTIONS.VIEW}
          >
            <VendorLazy>
              <VendorReport />
            </VendorLazy>
          </AbacProtectedRoute>
        ),
        vendorOrgOnly: true,
        abacResource: RESOURCE_TYPES.TICKET,
        abacAction: ACTIONS.VIEW,
      },
    ],
    // roles: ["Owner", "Employee"],
    plans: [1, 2, 3],
    planTypes: [2],
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },
  {
    name: "Energy Chart",
    key: "EnergyChartPage",
    route: "/energy-chart",
    component: <EnergyChart />,
  },
  {
    name: "Presentation",
    key: "PresentaionPage",
    route: "/presentation",
    component: <ProtectedRoute component={<Presentation />} />,
  },
  { type: "title", title: "Management", key: "title-pages", appMode: "flex2" },
  {
    type: "collapse",
    name: "Hardware & Devices",
    appMode: "flex2",
    key: "default",
    icon: <DevicesIcon />,
    hideForVendorOrg: true,
    collapse: [
      {
        name: "My devices",
        key: "devicePage",
        route: "/user/devices",
        component: (
          <AbacProtectedRoute
            component={DeviceManagement}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Bind Device",
        key: "bindDevice",
        route: "/user/bind-device",
        component: <ProtectedRoute component={<BindDevice />} />,
        roles: ["SUPER_ADMIN"],
      },
      {
        name: "View Status",
        key: "servicePage",
        route: "/view-status",
        component: <ProtectedRoute component={<ServiceStatus />} />,
      },
    ],
    roles: ["OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },

  // {
  //   type: "collapse",
  //   name: "Entity Management",
  //   key: "EntityManagement",
  //   icon: <GroupAddIcon />,
  //   collapse: [
  //     {
  //       name: "Company Listing",
  //       key: "CompanyListing",
  //       route: "/company-listing",
  //       component: <ProtectedRoute component={<EntityListing />} />,
  //     },
  //     {
  //       name: "Employee Listings",
  //       key: "Employee-Listings",
  //       route: "/employee-listings",
  //       component: <ProtectedRoute component={<EmployeeListing />} />,
  //     },
  //     {
  //       name: "Department",
  //       key: "Department",
  //       route: "/department-listings",
  //       component: <ProtectedRoute component={<CompanyDepartments />} />,
  //     },
  //     {
  //       name: "Qaulifications",
  //       key: "Qaulifications",
  //       route: "/qualifications-listings",
  //       component: <ProtectedRoute component={<CompanyQualifications />} />,
  //     },
  //     {
  //       name: "Invitations",
  //       key: "invitations",
  //       route: "/company-invitations",
  //       component: <ProtectedRoute component={<CompanyInvitations />} />,
  //     },
  //     {
  //       name: "Team Listings",
  //       key: "TeamListings",
  //       route: "/team-listings",
  //       component: <ProtectedRoute component={<CompanyTeams />} />,
  //     },
  //     {
  //       name: "System Tree",
  //       key: "SystemListings",
  //       route: "/system-tree",
  //       component: <ProtectedRoute component={<CompanySystemTree />} />,
  //     },
  //   ],
  //   roles: ["OWNER", "Employee"],
  //   plans: [1, 2, 3],
  // planTypes: [2]
  // },
  // {
  //   key: "viewPurchaseOrders",
  //   route: "/purchase-orders/view",
  //   component: <ProtectedRoute component={<PurchaseOrderDetailsPage />} />,
  // },
  // {
  //   name: "Create purchase order",
  //   key: "CreatePurchasePage",
  //   route: "/purchase-orders/create",
  //   component: <ProtectedRoute component={<CreatePurchaseOrder />} />,
  //   plans: [1, 2],
  // },
  {
    key: "ViewCompanyTeamPage",
    route: "/company/team",
    component: <ProtectedRoute component={<CompanyTeamUsers />} />,
  },

  // {
  //   type: "collapse",
  //   name: "Customer Management",
  //   key: "customerManagement",
  //   icon: <GroupAddIcon size="12px" />,
  //   collapse: [
  //     {
  //       name: "Customers",
  //       key: "CustomerPage",
  //       route: "/customer/listing",
  //       component: <ProtectedRoute component={<CustomerListingScreen />} />,
  //     },
  //   ],
  //   roles: ["SUPER_ADMIN", "OWNER", "Employee"],
  //   plans: [1, 2, 3],
  // planTypes: [2]
  // },
  {
    type: "collapse",
    name: "Commerce",
    appMode: "flex2",
    key: "products1",
    icon: <Inventory2OutlinedIcon />,
    collapse: [
      {
        name: "Product Listing",
        key: "productListing",
        route: "/products",
        component: (
          <AbacProtectedRoute
            component={FlexProducts}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Product Categories",
        key: "productCategories",
        route: "/product-categories",
        component: (
          <AbacProtectedRoute
            component={ProductCategories}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Brands",
        key: "brands",
        route: "/brands",
        component: (
          <AbacProtectedRoute
            component={BrandsListing}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Product Classes",
        key: "productClasses",
        route: "/product-classes",
        component: (
          <AbacProtectedRoute
            component={ProductClasses}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Inventory Location",
        key: "inventoryLocations",
        route: "/inventory-locations",
        component: (
          <AbacProtectedRoute
            component={InventoryLocations}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Parts",
        key: "partsListing",
        route: "/parts",
        component: (
          <AbacProtectedRoute
            component={PartsListing}
            resourceType={RESOURCE_TYPES.PART}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PART,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Services",
        key: "servicesListing",
        route: "/services",
        component: (
          <AbacProtectedRoute
            component={ServicesListing}
            resourceType={RESOURCE_TYPES.SERVICE}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.SERVICE,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Manufacturers",
        key: "manufacturers",
        route: "/manufacturers",
        component: (
          <AbacProtectedRoute
            component={ManufacturerListing}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Product Channels",
        key: "productChannels",
        route: "/product-channels",
        component: (
          <AbacProtectedRoute
            component={ProductChannelsListing}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Models",
        key: "models",
        route: "/models",
        component: (
          <AbacProtectedRoute
            component={ModelsListing}
            resourceType={RESOURCE_TYPES.PRODUCT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PRODUCT,
        abacAction: ACTIONS.VIEW,
      },

      {
        name: "Service Parts",
        key: "servicePart",
        route: "/servive-parts",
        component: (
          <AbacProtectedRoute
            component={ServiceParts}
            resourceType={RESOURCE_TYPES.PART}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.PART,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Order Products",
        key: "ProductsListPage",
        route: "/order-products",
        component: <ProtectedRoute component={<ProductListPage />} />,
      },
      {
        name: "Configurator Templates",
        key: "configuratorTemplates",
        route: "/product-configurator/templates",
        component: <ProtectedRoute component={<ConfiguratorTemplates />} />,
      },
      {
        name: "Configurator Option Groups",
        key: "configuratorOptionGroups",
        route: "/product-configurator/option-groups",
        component: <ProtectedRoute component={<ConfiguratorOptionGroups />} />,
      },
      {
        name: "Configurator Options",
        key: "configuratorOptions",
        route: "/product-configurator/options",
        component: <ProtectedRoute component={<ConfiguratorOptions />} />,
      },
      {
        name: "Configurator Rules",
        key: "configuratorRules",
        route: "/product-configurator/rules",
        component: <ProtectedRoute component={<ConfiguratorRules />} />,
      },
      {
        name: "Configurator Pricing Rules",
        key: "configuratorPricingRules",
        route: "/product-configurator/pricing-rules",
        component: <ProtectedRoute component={<ConfiguratorPricingRules />} />,
      },
    ],
    roles: ["SUPER_ADMIN", "OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
    abacResource: RESOURCE_TYPES.PRODUCT,
    abacAction: ACTIONS.VIEW,
  },
  {
    key: "addProduct",
    route: "/products/add",
    component: <AbacProtectedRoute component={AddFlexProduct} resourceType={RESOURCE_TYPES.PRODUCT} action={ACTIONS.CREATE} />,
  },
  {
    key: "editProduct",
    route: "/products/edit",
    component: <AbacProtectedRoute component={EditFlexProduct} resourceType={RESOURCE_TYPES.PRODUCT} action={ACTIONS.EDIT} />,
  },
  {
    key: "viewProduct",
    route: "/products/view",
    component: <AbacProtectedRoute component={ViewFlexProductPage} resourceType={RESOURCE_TYPES.PRODUCT} action={ACTIONS.VIEW} />,
  },
  {
    key: "adminViewAssignedProducts",
    route: "/admin/assigned-products",
    component: <AbacProtectedRoute component={AssignedProducts} resourceType={RESOURCE_TYPES.PRODUCT} action={ACTIONS.VIEW} />,
  },
  {
    key: "editModel",
    route: "/models/edit",
    component: <AbacProtectedRoute component={EditModel} resourceType={RESOURCE_TYPES.PRODUCT} action={ACTIONS.EDIT} />,
  },
  {
    key: "addProduct",
    route: "/parts/add",
    component: <AbacProtectedRoute component={AddPart} resourceType={RESOURCE_TYPES.PART} action={ACTIONS.CREATE} />,
  },
  {
    key: "editProduct",
    route: "/parts/edit",
    component: <AbacProtectedRoute component={EditPart} resourceType={RESOURCE_TYPES.PART} action={ACTIONS.EDIT} />,
  },
  {
    key: "viewProduct",
    route: "/parts/view",
    component: <AbacProtectedRoute component={PartDetails} resourceType={RESOURCE_TYPES.PART} action={ACTIONS.VIEW} />,
  },
  {
    key: "addService",
    route: "/services/add",
    component: (
      <AbacProtectedRoute
        component={AddService}
        resourceType={RESOURCE_TYPES.SERVICE}
        action={ACTIONS.CREATE}
      />
    ),
  },
  {
    key: "editService",
    route: "/services/edit",
    component: (
      <AbacProtectedRoute
        component={EditService}
        resourceType={RESOURCE_TYPES.SERVICE}
        action={ACTIONS.EDIT}
      />
    ),
  },


  {
    name: "Subscription View",
    key: "subscription-details",
    route: "/subscription",
    component: <ProtectedRoute component={<SubscriptionDetails />} />,
  },
  {
    name: "Partner Details",
    key: "partner-details",
    route: "/business-listing",
    component: <ProtectedRoute component={<CompanyDetails />} />,
  },
  {
    name: "Custom Subscription",
    key: "custom-subscription",
    route: "/custom-subscription",
    component: <ProtectedRoute component={<AddCustomSubscription />} />,
  },
  {
    key: "device-plan",
    route: "/device-plan",
    component: <ProtectedRoute component={<DevicePlan />} />,
  },
  {
    name: "Payment and Pricing",
    key: "payment-and-pricing",
    route: "/pricing",
    component: <ProtectedRoute component={<PaymentScreens />} />,
  },
  {
    name: "Checkout",
    key: "checkout",
    route: "/checkout",
    component: <ProtectedRoute component={<CheckoutScreen />} />,
  },
  {
    name: "Device Checkout",
    key: "deviceCheckout",
    route: "/device/checkout",
    component: <ProtectedRoute component={<DeviceCheckoutScreen />} />,
  },
  {
    name: "Checkout",
    key: "checkout",
    route: "/business/checkout",
    component: <BusinessCheckout />,
  },
  {
    name: "Subscription Payment",
    key: "subscriptionPayment",
    route: "/subscription/payment",
    component: <SubscriptionPayment />,
  },
  {
    name: "Device Details",
    key: "DeviceDetailsPage",
    route: "/devices/view",
    component: <AbacProtectedRoute component={ViewDevice} resourceType={RESOURCE_TYPES.DEVICE} action={ACTIONS.VIEW} />,
  },
  {
    name: "Device Authentication Setup",
    key: "deviceAuthSetup",
    route: "/admin/device-setup",
    component: <ProtectedRoute component={<DeviceSetup />} />,
  },
  {
    type: "collapse",
    name: "Facility Operations",
    appMode: "flex2",
    // Plan K Phase 2 — lane gate. Hides the whole group when the org has no
    // Facility-Operations entitlements (Tickets / Work Orders / Vendor
    // Coordination / Lift Inspections). Super Admin bypasses.
    laneKey: "lane.facility_operations",
    key: "workOrder",
    icon: <WorkOutlineOutlinedIcon />,
    collapse: [
      {
        name: "Work Orders",
        key: "workOrderlistPage",
        route: "/work-orders",
        component: (
          <AbacProtectedRoute
            component={WorkOrders}
            resourceType={RESOURCE_TYPES.WORK_ORDER}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.WORK_ORDER,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Tasks",
        key: "tasklistPage",
        route: "/tasks",
        component: (
          <AbacProtectedRoute
            component={TaskManagementPage}
            resourceType={RESOURCE_TYPES.WORK_ORDER}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.WORK_ORDER,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Tickets",
        key: "TicketPage",
        route: "/tickets",
        component: (
          <AbacProtectedRoute
            component={TicketListingScreen}
            resourceType={RESOURCE_TYPES.TICKET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.TICKET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Inspection Forms",
        key: "FormInspectionPage",
        route: "/inspections-forms",
        component: (
          <AbacProtectedRoute
            component={InspectionFormsListing}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      // The /inspections prefix is owned by the standalone inspections-webapp
      // now (nginx: "= /inspections" + "^~ /inspections/" → :3006). The old
      // in-bundle Inspections page and the sensor-aware runtime routes were
      // retired with it; /inspections-forms (different prefix) stays.
      {
        name: "Time Tracker",
        key: "trackedTimePage",
        route: "/time-tracker",
        component: <ProtectedRoute component={<TimeTracker />} />,
      },
      {
        name: "Invoices",
        key: "InvoiceListPage",
        route: "/invoices",
        component: (
          <AbacProtectedRoute
            component={InvoiceListing}
            resourceType={RESOURCE_TYPES.INVOICE}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.INVOICE,
        abacAction: ACTIONS.VIEW,
      },
    ],
    roles: ["OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
    abacResource: RESOURCE_TYPES.WORK_ORDER,
    abacAction: ACTIONS.VIEW,
  },
  {
    key: "CreateInvoicePage",
    route: "/invoice/create",
    component: <ProtectedRoute component={<CreateInvoice />} />,
  },
  {
    key: "CreateQuotesPage",
    route: "/quotes/create",
    component: <ProtectedRoute component={<CreateQuotes />} />,
  },

  {
    key: "InvoicePage",
    route: "/invoice/pdf",
    component: <ProtectedRoute component={<ViewInvoice />} />,
  },
  {
    key: "QuotesInvoicPage",
    route: "/invoice-quote/pdf",
    component: <ProtectedRoute component={<ViewQuaoteInvoice />} />,
  },
  {
    key: "InvoicePDFRoute",
    route: "/admin/invoices/:invoiceId/preview",
    component: <ProtectedRoute component={<AdminInvoicePreview />} />,
  },

  // {
  //   type: "collapse",
  //   name: "Inspections",
  //   key: "inspections",
  //   icon: <WorkOutlineOutlinedIcon />,
  //   collapse: [
  //     {
  //       name: "Listing",
  //       key: "inspectionsListPage",
  //       route: "/inspections",
  //       component: <ProtectedRoute component={<Inspections />} />,
  //     },
  //   ],
  //   roles: ["OWNER", "Employee", "SUPER_ADMIN"],
  //   plans: [1, 2, 3],
  // planTypes: [2]
  // },
  // {
  //   name: "Create Inspection",
  //   key: "createInspectionPage",
  //   route: "/inspections/create",
  //   component: <ProtectedRoute component={<CreateInspaction />} />,
  // },
  // {
  //   name: "Inspection Question",
  //   key: "InspectionQuestion",
  //   route: "/inspections/question",
  //   component: <ProtectedRoute component={<InspectionQuestions />} />,
  // },
  {
    name: "Form History Page",
    key: "FormHistoryPage",
    route: "/inspections-forms/history",
    component: <ProtectedRoute component={<FormHistoryPage />} />,
  },
  {
    name: "Create Inspection",
    key: "CreateInspectionPage",
    route: "/start-inspection",
    component: <ProtectedRoute component={<InspectionForm />} />,
  },
  {
    name: "Annual Inspection Certificate & Checklist",
    key: "AnnualInspection",
    route: "/annual-inspection",
    component: <ProtectedRoute component={<AnnualInspectionCertificateandChecklist />} />,
  },
  {
    name: "AnnualPdf",
    key: "AnnualInspectionPdf",
    route: "/annual-inspection-pdf",
    component: <ProtectedRoute component={<AnnualInspectionPdf />} />,
  },
  {
    name: "Inspection Pdf",
    key: "inspectionPdf",
    route: "/inspection/pdf",
    component: <InspectionPreview />,
  },
  {
    name: "Create Inspection Form",
    key: "CreateInspectionForm",
    route: "/inspections-forms/create",
    component: <ProtectedRoute component={<CreateInspectionForm />} />,
  },
  // /inspections/preview-form and /inspections/dynamic-inspection-preview
  // retired with the /inspections prefix handoff (see inspections-handoff).

  {
    name: "Create Work Order",
    key: "workOrderPage",
    route: "/work-orders/create",
    component: <ProtectedRoute component={<CreateWorkOrder />} />,
  },
  {
    name: "View Work Order",
    key: "viewWorkOrderPage",
    route: "/work-orders/view",
    component: <ProtectedRoute component={<WorkOrderDetails />} />,
  },
  {
    name: "Create Task",
    key: "CreateTaskPage",
    route: "/task/create",
    component: <ProtectedRoute component={<CreateTaskPage />} />,
  },
  {
    name: "View task",
    key: "viewTaskPage",
    route: "/task/view",
    component: <ProtectedRoute component={<TaskDetailsPage />} />,
  },
  {
    name: "Device Configurations",
    key: "deviceConfigPage",
    route: "/device/config",
    component: <ProtectedRoute component={<DeviceConfig />} />,
  },
  {
    name: "Subscription Details",
    key: "accountSubscriptions",
    route: "/account/subscription",
    component: <ProtectedRoute component={<MySubscription />} />,
  },
  {
    name: "Add Asset",
    key: "addAsset",
    route: "/assets/add",
    component: <ProtectedRoute component={<AddAsset />} />,
  },
  {
    name: "Add Asset",
    key: "addAsset",
    route: "/assets/sensor",
    component: <ProtectedRoute component={<AddSensor />} />,
  },
  {
    name: "Edit Asset",
    key: "editAsset",
    route: "/assets/edit",
    component: <ProtectedRoute component={<EditAsset />} />,
  },
  {
    type: "collapse",
    name: "Assets & Library",
    appMode: "flex2",
    key: "assetpages",
    icon: <HomeMaxIcon />,
    collapse: [
      {
        name: "Systems Library",
        key: "systems",
        route: "/systems",
        component: <ProtectedRoute component={<Systems />} />,
      },
      {
        name: "Assets Listing",
        key: "assetsPage",
        route: "/assets/listings",
        component: (
          <AbacProtectedRoute
            component={AssetsList}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Asset Classes",
        key: "assetsClassPage",
        route: "/assets/class",
        component: (
          <AbacProtectedRoute
            component={AssetClasses}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Systems",
        key: "systemCategories",
        route: "/assets/system-categories",
        component: (
          <AbacProtectedRoute
            component={SystemCategoriesListing}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
    ],
    roles: ["OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },
  {
    type: "collapse",
    name: "Insights",
    appMode: "flex2",
    key: "notifications1",
    icon: <TimelineIcon />,
    collapse: [
      {
        name: "Activity Timeline",
        key: "timlinePage",
        route: "/timeline",
        component: <ProtectedRoute component={<ActivityScreen />} />,
      },
      {
        name: "Notifications",
        key: "sensorNotifications",
        route: "/notifications",
        component: <ProtectedRoute component={<NotificationScreen />} />,
      },
      {
        name: "Notification History",
        key: "historyPage",
        route: "/notification/history",
        component: <ProtectedRoute component={<NotificationHistory />} />,
      },
    ],
    roles: ["OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
  },
  // My Account pages — surfaced in the top-right avatar menu (DashboardNavbar);
  // kept here as route-only entries so the URLs still resolve (no sidebar entry).
  {
    name: "My Subscription",
    key: "account-subscriptions",
    route: "/account/subscriptions",
    component: <ProtectedRoute component={<UserSubscriptions />} />,
  },
  {
    name: "Payment Methods",
    key: "account-payment-methods",
    route: "/account/payment-methods",
    component: <ProtectedRoute component={<PaymentMethods />} />,
  },
  {
    name: "Account Settings",
    key: "settingPage",
    route: "/account/setting",
    component: <ProtectedRoute component={<Setting />} />,
  },
  {
    name: "Sign-in & security",
    key: "account-security",
    route: "/account/security",
    component: <ProtectedRoute component={<SecurityPage />} />,
  },
  {
    name: "My Orders",
    key: "ordersListing",
    route: "/orders",
    component: (
      <AbacProtectedRoute
        component={OrdersPage}
        resourceType={RESOURCE_TYPES.ORDER}
        action={ACTIONS.VIEW}
      />
    ),
    abacResource: RESOURCE_TYPES.ORDER,
    abacAction: ACTIONS.VIEW,
  },
  {
    type: "collapse",
    name: "Platform Foundation",
    appMode: "flex2",
    key: "organizationSettings",
    icon: <CorporateFareIcon size="12px" />,
    collapse: [
      {
        name: "Locations",
        key: "LocationsPage",
        route: "/locations",
        component: (
          <AbacProtectedRoute
            component={Locations}
            resourceType={RESOURCE_TYPES.LOCATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.LOCATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "User Listing",
        key: "ListingPage",
        route: "/users/listing",
        component: <ProtectedRoute component={<UserListingScreen />} />,
      },
      {
        name: "Device Styles",
        key: "device-styles",
        route: "/device-styles",
        component: <ProtectedRoute component={<DeviceStyles />} />,
      },
      {
        name: "Claimed Devices",
        key: "claimed-devices",
        route: "/claimed-devices",
        component: <ProtectedRoute component={<ClaimedDevices />} />,
      },
      {
        name: "Partners",
        key: "partner-listings",
        route: "/business-listings",
        component: <ProtectedRoute component={<CompanyListing />} />,
      },
      {
        name: "Company Types",
        key: "company-Types",
        route: "/company-Types",
        component: <ProtectedRoute component={<CompanyTypes />} />,
      },
      // {
      //   name: "Create Organization",
      //   key: "createOrganizationPage",
      //   route: "/organizations/create",
      //   component: <AbacProtectedRoute component={CreateOrganization} resourceType={RESOURCE_TYPES.ORGANIZATION} action={ACTIONS.CREATE} />,
      // },
      {
        name: "Users",
        key: "usersPage",
        route: "/organization/users",
        component: (
          <AbacProtectedRoute
            component={OrganizationUsers}
            resourceType={RESOURCE_TYPES.USER}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.USER,
        abacAction: ACTIONS.VIEW,
      },
      // {
      //   name: "Teams",
      //   key: "teamPage",
      //   route: "/organization/teams",
      //   component: <AbacProtectedRoute component={Teams} resourceType={RESOURCE_TYPES.TEAM} action={ACTIONS.VIEW} />,
      // },
      {
        name: "Customers",
        key: "customerPage",
        route: "/customers",
        component: (
          <AbacProtectedRoute
            component={CustomerListingPage}
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Vendors",
        key: "vendorPage",
        route: "/vendors",
        component: (
          <AbacProtectedRoute
            component={VendorListingPage}
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "User Invitations",
        key: "invitePage",
        route: "/organization/invitaions",
        component: (
          <AbacProtectedRoute
            component={Invitations}
            resourceType={RESOURCE_TYPES.USER}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.USER,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Roles",
        key: "rolePage",
        route: "/organization/roles",
        component: (
          <AbacProtectedRoute
            component={Roles}
            resourceType={RESOURCE_TYPES.ROLE}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ROLE,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Departments",
        key: "departmentPage",
        route: "/organization/departments",
        component: (
          <AbacProtectedRoute
            component={Departments}
            resourceType={RESOURCE_TYPES.DEPARTMENT}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.DEPARTMENT,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Organizations",
        key: "organizationPage",
        route: "/organizations",
        component: (
          <AbacProtectedRoute
            component={Organizations}
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Qualifications",
        key: "qualificationPage",
        route: "/organization/qualifications",
        component: (
          <AbacProtectedRoute
            component={Qualifications}
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        // Org-level ABAC admin for OWNER + ABAC_ADMIN. The component
        // itself gates on isAbacAdmin() so even if a non-owner reaches
        // the route directly they see "Access Denied" instead of the
        // page. AbacProtectedRoute on Policy:View is a defense-in-depth
        // check (every seeded org has the matching policy for OWNER/
        // ABAC_ADMIN so this rejects only stripped-permission users).
        name: "ABAC Settings",
        key: "settingsAbac",
        route: "/settings/abac",
        component: (
          <AbacProtectedRoute
            component={SettingsAbac}
            resourceType={RESOURCE_TYPES.POLICY}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.POLICY,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Addresses",
        key: "addressPage",
        route: "/organization/addresses",
        component: (
          <AbacProtectedRoute
            component={AddressesListing}
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
    ],
    roles: ["SUPER_ADMIN", "OWNER", "Employee", "Partner"],
    plans: [2, 3],
    abacResource: RESOURCE_TYPES.ORGANIZATION,
    abacAction: ACTIONS.VIEW,
  },
  {
    name: "Vendor Details",
    key: "vendorDetails",
    route: "/vendors/view",
    component: <ProtectedRoute component={<VendorDetails />} />,
  },
  {
    name: "User Details",
    key: "userDetails",
    route: "/user/view",
    component: <ProtectedRoute component={<UserDetails />} />,
  },
  {
    name: "LocationPermission",
    key: "LocationPermissionPage",
    route: "/roles-permissions/location-permissions",
    component: <ProtectedRoute component={<LocationPermissions />} />,
  },
  {
    name: "DevicePermission",
    key: "DevicePermissionPage",
    route: "/device/permissions",
    component: <ProtectedRoute component={<DevicePermissions />} />,
  },
  {
    name: "ViewTeams",
    key: "ViewTeamPage",
    route: "/organizations/team",
    component: <ProtectedRoute component={<TeamUsers />} />,
  },
  {
    key: "addAddressPage",
    route: "/organization/addresses/add",
    component: <ProtectedRoute component={<CreateAddressPage />} />,
  },
  {
    key: "updateAddressPage",
    route: "/organization/addresses/edit",
    component: <ProtectedRoute component={<EditAddressPage />} />,
  },
  {
    name: "Widgets",
    key: "widget",
    icon: <WidgetsIcon />,
    collapse: [
      {
        name: "Chart Widgets",
        key: "widgetsPage",
        route: "/widgets/list",
        component: <ProtectedRoute component={<WidgetListing />} />,
      },
    ],
    roles: ["OWNER", "Employee", "Partner"],
    plans: [1, 2, 3],
    planTypes: [2],
  },
  {
    type: "collapse",
    name: "Leads & Contact",
    appMode: "flex2",
    key: "leadsManagement",
    icon: <LeaderboardIcon />,
    collapse: [
      {
        name: "Leads",
        key: "leadsPage",
        route: "/leads",
        component: <ProtectedRoute component={<LeadsManagement />} />,
      },
      {
        name: "Contact Messages",
        key: "widgetsPage",
        route: "/contact-messages",
        component: <ProtectedRoute component={<ContactMessages />} />,
      },
    ],
    roles: ["SUPER_ADMIN"],
  },
  {
    name: "Lead Details",
    key: "leadDetails",
    route: "/lead-details",
    component: <ProtectedRoute component={<LeadDetails />} />,
  },
  {
    name: "Contact Message Details",
    key: "cotnactMessageDetails",
    route: "/contact-message",
    component: <ProtectedRoute component={<ContactMessageDetails />} />,
  },
  {
    name: "Add Notification",
    key: "addNotification",
    route: "/notifications/add",
    component: <ProtectedRoute component={<AddNotificationScreen />} />,
  },
  {
    name: "Add Notification",
    key: "addNotification",
    route: "/notifications/:id",
    component: <ProtectedRoute component={<AddNotificationScreen />} />,
  },
  {
    name: "AddLocationPermission",
    key: "AddLocationPermissionPage",
    route: "/roles-permissions/location-permissions/add",
    component: <ProtectedRoute component={<AddLocationPermissions />} />,
  },


  {
    key: "CreateTicketPage",
    route: "/tickets/create",
    component: <ProtectedRoute component={<CreateTicket />} />,
  },
  {
    key: "editTicketPage",
    route: "/tickets/edit",
    component: <ProtectedRoute component={<EditTicket />} />,
  },
  {
    key: "AddMaintenancePage",
    route: "/maintenance/add",
    component: <ProtectedRoute component={<AddMaintenancePage />} />,
  },
  {
    key: "ticketDetails",
    route: "/tickets/view",
    component: <ProtectedRoute component={<TicketDetails />} />,
  },

  {
    key: "timeTrackerReport",
    route: "/time-tracker/report",
    component: <ProtectedRoute component={<TrackerReport />} />,
  },
  {
    key: "timeTrackerCreateInvoice",
    route: "/time-tracker/create-invoice",
    component: <ProtectedRoute component={<TimeTrackerCreateInvoice />} />,
  },
  // {
  //   key: "todayInvoiceviewPage",
  //   route: "/view/invoice",
  //   component: <ProtectedRoute component={<TimeTrackedInvoice />} />,
  // },
  {
    key: "InvoicePDFPage",
    route: "/invoice-pdf",
    component: <ProtectedRoute component={<InvoicePDF />} />,
  },

  {
    key: "ProductSearchPage",
    route: "/order-products/search",
    component: <ProtectedRoute component={<ProductSearch />} />,
  },
  {
    key: "ViewDetailsProductListPage",
    route: "/order-products/product",
    component: <ProtectedRoute component={<ProductDetails />} />,
  },

  {
    name: "Order Product Cart",
    key: "orderProductCart",
    route: "/order-product/cart",
    component: <ProtectedRoute component={<OrderCart />} />,
  },

  {
    name: "Order Product Checkout",
    key: "orderProductCheckout",
    route: "/order-product/checkout",
    component: <ProtectedRoute component={<OrderCheckout />} />,
  },

  {
    name: "Login Page",
    key: "loginPage",
    route: "/login",
    component: <LoginScreen />,
  },
  {
    type: "route",
    name: "Secure Link Redeem",
    key: "secure-link-redeem",
    route: "/secure-link/redeem",
    component: <Lazy><SecureLinkRedeem /></Lazy>,
  },
  {
    type: "route",
    name: "Driver Pickup",
    key: "afms-driver",
    route: "/afms/driver",
    component: <Lazy><DriverPickup /></Lazy>,
  },
  {
    type: "route",
    name: "Driver Pickup",
    key: "afms-driver-asset",
    route: "/afms/driver/:assetRef",
    component: <Lazy><DriverPickup /></Lazy>,
  },
  {
    name: "Forgot Password",
    key: "forgotPassword",
    route: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    name: "Sign-in Link",
    key: "login-link",
    route: "/login/link",
    component: <LoginLink />,
  },
  {
    name: "Set Password",
    key: "set-password",
    route: "/set-password",
    component: <SetPassword />,
  },
  {
    name: "Magic Login",
    key: "magic-login",
    route: "/auth-check",
    component: <AuthCheck />,
  },
  {
    // Single sign-on: where Keycloak returns a sign-in (auth/oidc).
    name: "Signing In",
    key: "auth-callback",
    route: "/auth/callback",
    component: <AuthCallback />,
  },
  {
    name: "Switching Organization",
    key: "switching-organization",
    route: "/switch-org",
    component: <SwitchOrg />,
  },
  {
    name: "SignUp",
    key: "sign-up",
    route: "/sign-up",
    component: <RegistrationScreen />,
  },
  {
    name: "privacyPolicy",
    key: "privacy-policy",
    route: "/privacy-policy",
    component: <PrivacyPolicy />,
  },
  {
    name: "cookie-Policy",
    key: "cookie",
    route: "/cookie-policy",
    component: <Cookies />,
  },
  {
    name: "Accept invitation Page",
    key: "acceptInvitationPage",
    route: "/invitations",
    component: <AcceptInvitation />,
  },
  {
    key: "viewOrder",
    route: "/orders/view",
    component: <ProtectedRoute component={<OrderDetails />} />,
    plans: [1, 2, 3],
    planTypes: [2],
  },
  {
    key: "adminViewOrder",
    route: "/admin/orders/view",
    component: <ProtectedRoute component={<AdminOrderDetails />} />,
    plans: [1, 2, 3],
    planTypes: [2],
  },

  // Quotations — re-enabled so the Fixed Ops portal sidebar's
  // /user/quotations/listing entry resolves. The two top-level menu
  // entries below appear in the legacy MAIN sidebar (gated by `roles`);
  // the Fixed Ops portal sidebar exposes the same routes under its
  // own Control Center grouping.
  {
    type: "collapse",
    name: "Quotations",
    key: "Customerquotations",
    icon: <Inventory2OutlinedIcon />,
    collapse: [
      {
        name: "My Quotations",
        key: "QuoteListing",
        route: "/user/quotations/listing",
        component: <ProtectedRoute component={<UserQuotationListing />} />,
      },
    ],
    roles: ["Owner", "Employee", "Partner"],
  },
  {
    type: "collapse",
    name: "Quotations",
    key: "quotation",
    icon: <Inventory2OutlinedIcon />,
    collapse: [
      {
        name: "Quote Listing",
        key: "QuoteManagement",
        route: "/admin/quotations/listing",
        component: <ProtectedRoute component={<AdminQuotationListing />} />,
      },
    ],
    roles: ["Super Admin"],
  },
  {
    key: "QuoteCreate",
    route: "/admin/quotations/create",
    component: <ProtectedRoute component={<AdminQuotationCreate />} />,
  },
  {
    key: "QuoteListAlias",
    route: "/user/quotations/list",
    component: <ProtectedRoute component={<UserQuotationListing />} />,
  },
  {
    key: "UserQuotationDetails",
    route: "/user/quotations/:quoteId/details",
    component: <ProtectedRoute component={<UserQuotationDetails />} />,
  },
  {
    key: "QuotationDetails",
    route: "/admin/quotations/:quoteId/details",
    component: <ProtectedRoute component={<AdminQuotationDetails />} />,
  },
  {
    key: "QuotationPDF",
    route: "/admin/quotations/:quoteId/preview",
    component: <ProtectedRoute component={<AdminQuotationPreview />} />,
  },
  {
    key: "QuoteOnlineCheckout",
    route: "/user/quotations/:quoteId/online-checkout",
    component: <ProtectedRoute component={<UserQuotationOnlineCheckout />} />,
  },
  // ── Platform Health — single-item entry pinned ABOVE the four
  //    backoffice collapses. Also the default landing page for the
  //    backoffice org (see getDefaultRoute in config/appMode.js).
  {
    // Site Builder — a LAUNCHER, not a page. The UI lives in site-webapp; this
    // entry's route is handed off by the /site/* catch-all further down, so
    // clicking the menu item leaves this bundle entirely.
    //
    // NOTE: adding a top-level backoffice menu also requires its key in
    // PLATFORM_KEYS in src/pages/components/Sidenav/index.js, or the backoffice
    // filter drops it with no error.
    type: "collapse",
    name: "Site Builder",
    key: "platform-site-builder",
    icon: <MapOutlinedIcon />,
    route: "/site/builder",
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    noCollapse: true,
    component: <SiteHandoff />,
  },
  {
    type: "collapse",
    name: "Platform Health",
    key: "platform-health",
    icon: <MonitorHeartIcon />,
    route: "/platform/health",
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    noCollapse: true,
    component: <ProtectedRoute component={<PlatformHealth />} />,
  },
  // ── Resources — operational, cross-service tooling that doesn't
  //    fit cleanly under any single domain (notifications queue,
  //    future: feature flags, background jobs, etc.).
  {
    type: "collapse",
    name: "Resources",
    key: "platform-resources",
    icon: <HubIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      {
        // Platform-wide LLM credentials — the keys every org's AI features run on,
        // so a platform resource rather than an org setting. First in the list
        // because nothing AI-related works until a provider is configured here.
        name: "AI Settings",
        key: "platformAiSettings",
        route: "/platform/ai-settings",
        component: <ProtectedRoute component={<AiSettings />} />,
      },
      {
        // Writes the table the MQTT broker authenticates against, so it is a
        // platform resource rather than an org setting — which is why it moved
        // here out of Platform Foundation.
        //
        // NOTE the environment asymmetry: flex2-api derives this connection
        // from DefaultConnection by swapping in Database=emqx_auth, so on dev
        // it edits a LOCAL stand-in table and the live broker is unaffected,
        // while in production it edits the real credential store shared by
        // every environment. The page looks identical in both.
        name: "Device Authentication",
        key: "device-auth",
        route: "/device-auth",
        component: <ProtectedRoute component={<DeviceAuthListings />} />,
      },
      {
        name: "Notifications",
        key: "platformNotifications",
        route: "/platform/notifications",
        component: <ProtectedRoute component={<PlatformNotifications />} />,
      },
      {
        name: "Legacy Notifications",
        key: "legacySensorNotifications",
        route: "/notifications",
        component: <ProtectedRoute component={<NotificationScreen />} />,
      },
      {
        name: "Keycloak",
        key: "keycloakLookupPage",
        route: "/platform/keycloak",
        component: <ProtectedRoute component={<KeycloakLookup />} />,
      },
      {
        // Page files shipped in commit 62c9233d but the route entry was
        // dropped before commit — page existed without a way to reach
        // it. Re-wired here so the sidebar surfaces the per-user ABAC
        // matrix under Resources alongside Notifications + Keycloak.
        name: "User Security",
        key: "platformUserSecurity",
        route: "/platform/user-security",
        component: <ProtectedRoute component={<PlatformUserSecurity />} />,
      },
      {
        // Read-only SQL console — paste a SELECT + the lee_readonly password
        // to query the production Postgres. Backend enforces read-only.
        name: "SQL Console",
        key: "platformSqlConsole",
        route: "/platform/sql-console",
        component: <ProtectedRoute component={<SqlConsole />} />,
      },
      {
        // Read-only S3 explorer — drill the assets bucket folder structure
        // and download files. Backend is Super-Admin gated.
        name: "S3 Bucket Explorer",
        key: "platformS3Explorer",
        route: "/platform/s3-explorer",
        component: <ProtectedRoute component={<S3Explorer />} />,
      },
      {
        // Dev-only: recent git commits across the monorepo repos, grouped by
        // date. Backend (/api/work-commits) returns available=false off the
        // dev server, so this degrades to a "dev only" note in production.
        name: "Work / Commits",
        key: "platformWorkCommits",
        route: "/platform/work-commits",
        component: <ProtectedRoute component={<WorkCommits />} />,
      },
      {
        // Sits with Work / Commits rather than under Legacy — same
        // dev-workflow surface. Route keeps its /platform-legacy prefix so
        // existing links and bookmarks still resolve.
        name: "Code Plans",
        key: "code-plans",
        route: "/platform-legacy/code-plans",
        component: <ProtectedRoute component={<CodePlans />} />,
        roles: ["SUPER_ADMIN"],
      },
    ],
  },
  // ── Platform admin — split into four collapses (Organizations,
  //    Environmental, LiftConnect Pro, Legacy) so the backoffice nav
  //    isn't one 30-item wall. All four share `roles: ["SUPER_ADMIN"]`
  //    + `appMode: "flex2"` so non-admins still don't see them. Each
  //    collapse uses a fresh `key` so localStorage open-state from the
  //    old single "platform" entry doesn't auto-expand the new groups
  //    on first paint — they all start closed.
  {
    type: "collapse",
    name: "Organizations",
    key: "platform-organizations",
    icon: <CorporateFareIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      {
        name: "All Organizations",
        key: "allOrganisationsListing",
        route: "/admin/organisations",
        component: <ProtectedRoute component={<AdminOrganisations />} />,
      },
      {
        name: "Manage Organizations",
        key: "orgAdminManage",
        route: "/organization-admin",
        component: <ProtectedRoute component={<OrganizationAdmin />} />,
      },
      {
        name: "Organization Explorer",
        key: "orgExplorer",
        route: "/organization-explorer",
        component: <ProtectedRoute component={<OrganizationExplorer />} />,
      },
      {
        name: "Impersonation Logs",
        key: "impersonationLogs",
        route: "/impersonation-logs",
        component: <ProtectedRoute component={<ImpersonationLogs />} />,
      },
      {
        name: "Assets Listing",
        key: "platformAssetsPage",
        route: "/assets/listings",
        component: (
          <AbacProtectedRoute
            component={AssetsList}
            resourceType={RESOURCE_TYPES.ASSET}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.ASSET,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Bind Device",
        key: "platformBindDevice",
        route: "/user/bind-device",
        component: <ProtectedRoute component={<BindDevice />} />,
      },
      {
        name: "Device Style Telemetry",
        key: "deviceStyleTelemetryAdmin",
        route: "/super-admin/device-style-telemetry",
        component: <ProtectedRoute component={<DeviceStyleTelemetryAdmin />} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Environmental",
    key: "platform-environmental",
    icon: <FilterVintageIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      {
        name: "Recycling Types",
        key: "recyclingTypesAdmin",
        route: "/super-admin/recycling-types",
        component: <ProtectedRoute component={<RecyclingTypesAdmin />} />,
      },
      {
        name: "Environmental Subscriptions",
        key: "platform-environmental-subscriptions",
        route: "/platform/environmental/subscriptions",
        component: <ProtectedRoute component={<EnvironmentalSubscriptionsAdmin />} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "LiftConnect Pro",
    key: "platform-lcp",
    icon: <HomeMaxIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      // NOTE: LCP Global Tasks / Comments / Deferrals moved to the LCP portal
      // (org-owned) under Settings → LCP Settings → Resources Setup. Lift
      // Models remain here but now curate the shared GLOBAL catalog
      // (organization_id NULL); orgs add their own via Resources Setup.
      {
        name: "Lift Models",
        key: "platform-lcp-lift-models",
        route: "/platform/lcp/lift-models",
        component: (
          <ProtectedRoute component={<LcpLiftModelsAdmin scope="global" />} />
        ),
      },
      {
        // Global Lift Parts catalog — upload SVI parts master + BOM lines,
        // browse by manufacturer/model, edit individual parts, reconcile
        // catalog model_codes to lcp-api LiftModel rows.
        name: "Global Lift Parts",
        key: "platform-lcp-lift-parts",
        route: "/platform/lcp/lift-parts",
        component: <ProtectedRoute component={<LcpLiftParts />} />,
      },
      {
        // Read-only troubleshooting view of every LCP approval instance
        // for the selected org — routed to, signed off, decision history.
        // Backs lcp-api /approvals/admin/list (platform-admin gated).
        name: "Approvals Inspector",
        key: "platform-lcp-approvals",
        route: "/platform/lcp/approvals",
        component: <ProtectedRoute component={<LcpApprovalsInspector />} />,
      },
      {
        // Label Orders — inspectors order pre-printed lift labels from
        // /lcp/order-labels; Flex2 super-admins review here and mark them
        // sent-to-printer. Backs lcp-api /label-orders/admin/list.
        name: "Label Orders",
        key: "platform-lcp-label-orders",
        route: "/platform/lcp/label-orders",
        component: <ProtectedRoute component={<LcpLabelOrders />} />,
      },
      {
        // Audit — the lifecycle trail of every annual inspection (who did
        // what, when), plus a per-org backfill for inspections that closed
        // before the trail existed. Backs lcp-api
        // /yearly-inspections/audit/{coverage,backfill}.
        name: "Audit",
        key: "platform-lcp-audit",
        route: "/platform/lcp/audit",
        component: <ProtectedRoute component={<LcpInspectionAudit />} />,
      },
      {
        // Checklist Pins — the one-time pass that freezes the checklist of
        // every inspection created before pinning existed. Until an
        // inspection is pinned it still resolves its questions live, so a
        // catalogue edit silently changes what it appears to have asked.
        // Backs lcp-api /yearly-inspections/checklist-backfill-{status,queue}.
        name: "Checklist Pins",
        key: "platform-lcp-checklist-pins",
        route: "/platform/lcp/checklist-pins",
        component: <ProtectedRoute component={<LcpChecklistPins />} />,
      },
    ],
  },
  ...(DEVICES_WEBAPP_URL ? [{
    // Devices vertical. The pages live in devices-webapp, which is a separate
    // SPA on its own HOST (devices.<domain>) rather than a path prefix on this
    // one — /claim has to stay at the root there because shipped firmware
    // builds that URL. So this is an href, not a handoff route like
    // /energy/* or /site/*: there is no same-origin path to hand off to.
    //
    // Sidenav renders an href child with target="_blank", so View Devices
    // opens in a new tab. Nothing in this bundle needs to know the page.
    //
    // Hidden entirely when REACT_APP_DEVICES_WEBAPP_URL is unset, which is
    // every environment where devices-webapp is not deployed — better no menu
    // than one that leads nowhere.
    type: "collapse",
    name: "Devices",
    key: "platform-devices",
    icon: <MemoryRoundedIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      {
        // The only entry: View Devices and Screen Layout used to sit here too,
        // but every route into devices-webapp comes through this menu, so
        // landing on the overview and using its Go to menu is one list
        // shorter and one less place to keep in step.
        name: "Goto Devices",
        key: "platform-devices-main",
        href: devicesLink("/platform/devices-main"),
      },
    ],
  }] : []),
  {
    type: "collapse",
    name: "Legacy",
    key: "platform-legacy",
    icon: <InventoryIcon />,
    appMode: "flex2",
    roles: ["SUPER_ADMIN"],
    collapse: [
      {
        name: "Ops Tools",
        key: "admin-ops-tools",
        route: "/admin/ops-tools",
        component: <ProtectedRoute component={<AdminOpsTools />} />,
      },
      {
        name: "Trials & Sponsors",
        key: "admin-trials",
        route: "/admin/trials",
        component: <ProtectedRoute component={<TrialsAdmin />} />,
      },
      {
        name: "Policy Studio (legacy)",
        key: "abacPolicyStudioLegacy",
        route: "/abac-admin",
        component: <ProtectedRoute component={<AbacAdmin />} />,
        // Keep mounted during soak window so deep links still work; new
        // surface is /platform/abac (Platform ABAC).
        hidden: true,
      },
      {
        name: "Platform ABAC",
        key: "platformAbac",
        route: "/platform/abac",
        component: (
          <AbacProtectedRoute
            component={PlatformAbac}
            resourceType={RESOURCE_TYPES.POLICY}
            action={ACTIONS.VIEW}
          />
        ),
        abacResource: RESOURCE_TYPES.POLICY,
        abacAction: ACTIONS.VIEW,
        roles: ["SUPER_ADMIN"],
      },
      {
        name: "All Orders",
        key: "allOrdersListing",
        route: "/admin/orders",
        component: <ProtectedRoute component={<AdminOrders />} />,
      },
      {
        name: "Subscriptions",
        key: "subscriptions",
        route: "/subscriptions",
        component: <ProtectedRoute component={<SubscriptionListing />} />,
      },
      {
        name: "Prices",
        key: "prices",
        route: "/prices",
        component: <ProtectedRoute component={<Prices />} />,
      },
      {
        name: "Subscription Plans",
        key: "subscriptionPlans",
        route: "/subscription-plans",
        component: <ProtectedRoute component={<SubscriptionPlans />} />,
      },
      {
        name: "Discounts",
        key: "discounts",
        route: "/discounts",
        component: <ProtectedRoute component={<Discounts />} />,
      },
      {
        name: "Agent runs",
        key: "agentRuns",
        route: "/platform/agents/runs",
        component: <ProtectedRoute component={<AgentRunsScreen />} />,
      },
      {
        name: "Approvals queue",
        key: "agentApprovals",
        route: "/platform/approvals",
        component: <ProtectedRoute component={<AgentApprovalsScreen />} />,
      },
      {
        name: "Entitlements",
        key: "entitlements",
        route: "/platform/entitlements",
        component: <ProtectedRoute component={<EntitlementsScreen />} />,
      },
      {
        name: "SKU catalog",
        key: "skus",
        route: "/platform/skus",
        component: <ProtectedRoute component={<SkusScreen />} />,
      },
      {
        name: "Pelican sites",
        key: "pelicanSites",
        route: "/platform/pelican",
        component: <ProtectedRoute component={<PelicanSitesScreen />} />,
      },
      {
        name: "Role taxonomy",
        key: "taxonomy",
        route: "/platform/taxonomy",
        component: <ProtectedRoute component={<TaxonomyScreen />} />,
      },
      {
        name: "AFMS workflow",
        key: "afmsWorkflow",
        route: "/platform/afms/workflow",
        component: <ProtectedRoute component={<AfmsWorkflowScreen />} />,
      },
      // Vendor Program admin surfaces (23-04 plan Part 3.3, shipped 2026-04-24).
      {
        name: "Parts master review",
        key: "partsMasterReview",
        route: "/platform/vendor-program/parts-master",
        component: <ProtectedRoute component={<PartsMasterReviewScreen />} />,
      },
      {
        name: "Organization relationships",
        key: "organizationRelationships",
        route: "/platform/vendor-program/relationships",
        component: <ProtectedRoute component={<OrganizationRelationshipsScreen />} />,
      },
      {
        name: "Vendor sites",
        key: "vendorSites",
        route: "/platform/vendor-program/sites",
        component: (
          <AbacProtectedRoute
            resourceType={RESOURCE_TYPES.ORGANIZATION}
            action={ACTIONS.VIEW}
          >
            <VendorSitesScreen />
          </AbacProtectedRoute>
        ),
        abacResource: RESOURCE_TYPES.ORGANIZATION,
        abacAction: ACTIONS.VIEW,
      },
      {
        name: "Quote / order requests",
        key: "quoteOrderRequests",
        route: "/platform/vendor-program/requests",
        component: <ProtectedRoute component={<QuoteOrderRequestsScreen />} />,
      },
      {
        name: "Hardware categories",
        key: "hardwareCategories",
        route: "/platform/hardware/categories",
        component: <ProtectedRoute component={<HardwareCategoriesScreen />} />,
      },
      {
        name: "Approved hardware",
        key: "approvedHardware",
        route: "/platform/hardware/approved-products",
        component: <ProtectedRoute component={<ApprovedHardwareProductsScreen />} />,
      },
      {
        name: "Hardware orders",
        key: "hardwareOrders",
        route: "/platform/hardware/orders",
        component: <ProtectedRoute component={<HardwareOrdersScreen />} />,
      },
      {
        name: "Device installations",
        key: "deviceInstallations",
        route: "/platform/devices/installations",
        component: <ProtectedRoute component={<DeviceInstallationsScreen />} />,
      },
      {
        name: "Audit events",
        key: "auditEvents",
        route: "/platform/audit-events",
        component: <ProtectedRoute component={<AuditEventsScreen />} />,
      },
    ],
  },
  // Taxonomy sub-pages (not in sidenav — reached via the chip sub-nav on /platform/taxonomy)
  {
    key: "taxonomyCrmRules",
    route: "/platform/taxonomy/crm-rules",
    component: <ProtectedRoute component={<TaxonomyCrmRulesScreen />} />,
  },
  {
    key: "taxonomyPermissionTemplates",
    route: "/platform/taxonomy/permission-templates",
    component: <ProtectedRoute component={<TaxonomyPermissionTemplatesScreen />} />,
  },
  {
    key: "taxonomyPartnerProfiles",
    route: "/platform/taxonomy/partner-profiles",
    component: <ProtectedRoute component={<TaxonomyPartnerProfilesScreen />} />,
  },
  {
    key: "taxonomyPartnerLocator",
    route: "/platform/taxonomy/partner-locator",
    component: <ProtectedRoute component={<TaxonomyPartnerLocatorScreen />} />,
  },
  {
    key: "taxonomyStaleFamilies",
    route: "/platform/taxonomy/stale",
    component: <ProtectedRoute component={<TaxonomyStaleFamiliesScreen />} />,
  },
  // Pelican site detail — unified dashboard per F2 Pelican blueprint §6 (8 tabs, shared shell)
  {
    key: "pelicanSiteOverview",
    route: "/platform/pelican/:id",
    component: <ProtectedRoute component={<PelicanSiteOverview />} />,
  },
  {
    key: "pelicanSiteOperations",
    route: "/platform/pelican/:id/operations",
    component: <ProtectedRoute component={<PelicanSiteOperations />} />,
  },
  {
    key: "pelicanSiteClimate",
    route: "/platform/pelican/:id/climate",
    component: <ProtectedRoute component={<PelicanClimate />} />,
  },
  {
    key: "pelicanSiteSchedules",
    route: "/platform/pelican/:id/schedules",
    component: <ProtectedRoute component={<PelicanSchedules />} />,
  },
  {
    key: "pelicanSitePower",
    route: "/platform/pelican/:id/power",
    component: <ProtectedRoute component={<PelicanPower />} />,
  },
  {
    key: "pelicanSiteNotifications",
    route: "/platform/pelican/:id/notifications",
    component: <ProtectedRoute component={<PelicanNotifications />} />,
  },
  {
    key: "pelicanSiteUsage",
    route: "/platform/pelican/:id/usage",
    component: <ProtectedRoute component={<PelicanUsage />} />,
  },
  {
    key: "pelicanSiteAutomation",
    route: "/platform/pelican/:id/automation",
    component: <ProtectedRoute component={<PelicanAutomation />} />,
  },
  // Detail pages (not in sidenav)
  {
    key: "agentRunDetail",
    route: "/agents/runs/:id",
    component: <ProtectedRoute component={<AgentRunDetailScreen />} />,
  },
];

// Vendor Portal routes - shown for VENDOR role users.
// All three operate over assets at a granted client org, so they gate on
// Asset:View. The HasActiveVendorGrant condition on the seeded
// "Vendor - Portal Asset View (Granted Clients)" policy enforces that the
// :clientOrgId in the route corresponds to an active VendorAccessGrant.
const environmentalPortalRoutes = [
  {
    name: "Client Site Overview",
    key: "vendorClientSiteOverview",
    route: "/vendor/clients/:clientOrgId/overview",
    component: (
      <AbacProtectedRoute
        resourceType={RESOURCE_TYPES.ASSET}
        action={ACTIONS.VIEW}
      >
        <VendorLazy>
          <ClientSiteOverview />
        </VendorLazy>
      </AbacProtectedRoute>
    ),
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },
  {
    name: "Client Tanks",
    key: "vendorClientTanks",
    route: "/vendor/clients/:clientOrgId/tanks",
    component: (
      <AbacProtectedRoute
        resourceType={RESOURCE_TYPES.ASSET}
        action={ACTIONS.VIEW}
      >
        <VendorLazy>
          <ClientTankListing />
        </VendorLazy>
      </AbacProtectedRoute>
    ),
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },
  {
    name: "Client Tank Detail",
    key: "vendorClientTankDetail",
    route: "/vendor/clients/:clientOrgId/tanks/view",
    component: (
      <AbacProtectedRoute
        resourceType={RESOURCE_TYPES.ASSET}
        action={ACTIONS.VIEW}
      >
        <VendorLazy>
          <ClientTankDetail />
        </VendorLazy>
      </AbacProtectedRoute>
    ),
    abacResource: RESOURCE_TYPES.ASSET,
    abacAction: ACTIONS.VIEW,
  },
];

const routes = [
  ...flex2Routes,
  ...environmentalPortalRoutes,
  ...afmsRoutes,
  ...fixedOpsRoutes,
  ...lcpRoutes,
  // Energy vertical — now served by the standalone energy-webapp. See
  // src/energy/EnergyHandoff.js; energy page code under src/energy/ is
  // frozen here (source of truth moved to the energy-webapp repo).
  {
    // Site Builder lives in site-webapp (nginx: /site/* -> :3003). Any deep link
    // or pasted URL under /site becomes a full page load. Same shape as the
    // Energy handoff above it.
    type: "route",
    name: "Site",
    key: "site-handoff",
    route: "/site/*",
    component: <SiteHandoff />,
  },
  {
    type: "route",
    name: "Energy",
    key: "energy-handoff",
    route: "/energy/*",
    component: <EnergyHandoff />,
  },
  {
    // Training is served by the standalone training-webapp (:3005), so any
    // SPA navigation or pasted URL under /training becomes a full page load.
    // Same shape as the Energy and Site handoffs above.
    type: "route",
    name: "Training",
    key: "training-handoff",
    route: "/training/*",
    component: <TrainingHandoff />,
  },
  {
    // Inspections is served by the standalone inspections-webapp (:3006), so
    // any SPA navigation or pasted URL under /inspections becomes a full page
    // load. Same shape as the Energy / Site / Training handoffs above.
    type: "route",
    name: "Inspections",
    key: "inspections-handoff",
    route: "/inspections/*",
    component: <InspectionsHandoff />,
  },
  ...spendguardRoutes,
  ...enterpriseRoutes,
  ...lotoRoutes,
  ...safetyRoutes,
  ...auditApiRoutes,
];

export default routes;
